import StepCard from "./components/StepCard";
import scheduleImg from "../../../assets/img/apponboarding/schedule.svg";

const StepScheduleJob = ({ onCtaClick, onSkip, stepNumber, selectedOrganization }) => {
  const isOperation = selectedOrganization?.type === "operation";
  const ctaLabel = isOperation ? "Schedule Task" : "Schedule Job";
  return (
  <StepCard
    stepLabel={`Step ${stepNumber}`}
    title={`Schedule a ${isOperation ? "Task" : "Job"}`}
    description={`Assign a date, time, and team member so everyone knows when and where to be.`}
    ctaLabel={ctaLabel}
    onCtaClick={onCtaClick}
    onSkip={onSkip}
    mediaSrc={null}
    selectedOrganization={selectedOrganization}
    backgroundColor="#A7C2F9"
    backgroundImage={scheduleImg}
    videoUrl="https://youtu.be/I1c3J8at1bI"
  />
  );
};

export default StepScheduleJob;
